import {
  addChatsApi,
  addContactsApi,
  addTicketsApi,
  addCustomerApi,
  addCustomerFormFieldApi,
  addDashboardApi,
  addDriveApi,
  addEntitiesApi,
  addEntitySpacesApi,
  addIntegrationsApi,
  addInventoryApi,
  addLinksApi,
  addLocationApi,
  addModuleNotificationsApi,
  addTasksApi,
  addUsersApi,
  addWorkspacesApi,
  addAIAssistantApi,
  addSubscriptionV2Api,
  addAIWorkflowsApi,
  addShopifyApi,
  baseQuery,
  omitApiRequestMeta,
  WithApiRequestMeta,
} from "@jugl-web/rest-api";
import { addAuthApi } from "@jugl-web/rest-api/auth/authApi";
import { addInvoicesApi } from "@jugl-web/rest-api/invoices/invoicesApi";
import { addOrdersApi } from "@jugl-web/rest-api/orders";
import { addTasksCommentsApi } from "@jugl-web/rest-api/tasks-comments";
import { addTasksTemplatesApi } from "@jugl-web/rest-api/tasks-templates";
import { defaultSerializeQueryArgs } from "@reduxjs/toolkit/query";
import { createApi } from "@reduxjs/toolkit/query/react";
import { environment } from "@web-src/environments/environment";
import Geocode from "react-geocode";
import api from "./api";

Geocode.setApiKey(environment.geocodingKey);

export const baseQueryObj = baseQuery(api);

type OpenGraphSiteResponse = {
  openGraph?: {
    title?: string;
    description?: string;
    image?: { url?: string };
  };
  hybridGraph?: {
    title?: string;
    description?: string;
    image?: string;
  };
};

export const emptySplitApi = createApi({
  baseQuery: baseQuery(api),
  // Request `meta` must not affect cache keys
  serializeQueryArgs: (params) =>
    defaultSerializeQueryArgs({
      ...params,
      queryArgs: omitApiRequestMeta(params.queryArgs),
    }),
  endpoints: (build) => ({
    openGraph: build.query<
      OpenGraphSiteResponse,
      WithApiRequestMeta<{ url: string }>
    >({
      query: ({ url }) => ({
        url: `https://opengraph.io/api/1.1/site/${encodeURIComponent(
          url
        )}?app_id=3c6c16c9-66db-465d-b3e0-ae987f90cda4`,
        isPublic: true,
      }),
    }),
  }),
});

// oxlint-disable-next-line typescript/ban-ts-comment
// @ts-ignore
emptySplitApi._baseQuery = baseQueryObj;

export const locationApi = addLocationApi(emptySplitApi);

export const tasksApi = addTasksApi(emptySplitApi);

export const tasksCommentsApi = addTasksCommentsApi(emptySplitApi);

export const tasksTemplatesApi = addTasksTemplatesApi(emptySplitApi);

export const usersApi = addUsersApi(emptySplitApi);

export const workspacesApi = addWorkspacesApi(emptySplitApi);

export const { useOpenGraphQuery } = emptySplitApi;

export const customerFormFieldApi = addCustomerFormFieldApi(emptySplitApi);

export const contactsApi = addContactsApi(emptySplitApi);

export const ticketsApi = addTicketsApi(emptySplitApi);

export const customerApi = addCustomerApi(emptySplitApi);

export const dashboardApi = addDashboardApi(emptySplitApi);

export const driveApi = addDriveApi(emptySplitApi);

export const moduleNotificationsApi = addModuleNotificationsApi(emptySplitApi);

export const authApi = addAuthApi(emptySplitApi);

export const entitiesApi = addEntitiesApi(emptySplitApi);

export const entitySpacesApi = addEntitySpacesApi(emptySplitApi);

export const linksApi = addLinksApi(emptySplitApi);

export const ordersApi = addOrdersApi(emptySplitApi);

export const inventoryApi = addInventoryApi(emptySplitApi);

export const integrationsApi = addIntegrationsApi(emptySplitApi);

export const chatsApi = addChatsApi(emptySplitApi);

export const invoicesApi = addInvoicesApi(emptySplitApi);

export const aiAssistantApi = addAIAssistantApi(emptySplitApi);

export const subscriptionV2Api = addSubscriptionV2Api(emptySplitApi);

export const aiWorkflowsApi = addAIWorkflowsApi(emptySplitApi);

export const shopifyApi = addShopifyApi(emptySplitApi);
